module.exports = __webpack_public_path__ + "static/media/antique.6c3a9f26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/antique.svg
// module id = 3062
// module chunks = 0